"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleSectionIDInjectionKey = exports.RoleViewSelectedRole = exports.RoleViewTemplateStore = exports.RoleSectionUserStore = exports.RoleViewMeStore = exports.RoleSectionArray = exports.RoleViewInjectionKey = void 0;
// Type-safe provide-inject: https://vuejs.org/api/composition-api-dependency-injection
exports.RoleViewInjectionKey = Symbol('roleViewInject');
exports.RoleSectionArray = Symbol('roleSectionArray');
exports.RoleViewMeStore = Symbol('meStore');
exports.RoleSectionUserStore = Symbol('userStore');
exports.RoleViewTemplateStore = Symbol('templateStore');
exports.RoleViewSelectedRole = Symbol('selectedRole');
exports.RoleSectionIDInjectionKey = Symbol('roleSectionID');
